import React from "react";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import { useErrorDialog } from "../../context/ErrorDialogContext";

export const ErrorDialog = () => {
  const { errorState, hideError } = useErrorDialog();

  return (
    <Dialog
      open={errorState.isOpen}
      onOpenChange={(_, data) => !data.open && hideError()}
      modalType="alert" // Ensures it's treated as a blocking modal
      trapFocus // Keeps focus inside the dialog
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{errorState.title}</DialogTitle>
          <p>{errorState.message}</p>
          <DialogActions>
            <Button appearance="primary" onClick={hideError}>
              Close
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
